import { initPopupBackButtonHandler } from 'utils/popupBackButtonHandler';

import { initializeMobx } from './initializeMobx';
import { initializeSentry } from './initializeSentry';
import { initializeYm } from './initializeYm';

export const initialize = () => {
  initPopupBackButtonHandler();
  initializeMobx();
  initializeSentry();
  initializeYm();
};
